import { message } from "antd";
const { DataService } = require("../../config/dataService/dataService");
const { API } = require("../../config/api/index");


export const isbnAddData = (value) => {
  return async (dispatch) => {
    const resp = await DataService.post(API.isbn.isbnCreate, value);
    if (!resp.data.error) {
      return resp.data.data;
    } else {
      message.error(resp.data.message);
    }
  };
};
export const isbnUpdateData = (id, value) => {
  return async (dispatch) => {
    const resp = await DataService.put(
      API.isbn.isbnCreate + "/" + id,
      value
    );
    if (!resp.data.error) {
      return resp.data.data;
    } else {
      message.error(resp.data.message);
    }
  };
};

export const getIsbnData = (page, limit) => {
  return async (dispatch) => {
    const resp = await DataService.get(
      API.isbn.isbnCreate + "?page=" + page + "&limit=" + limit
    );
    if (!resp?.data?.error) {
      return resp?.data;
    } else {
      message.error(resp.data.message);
    }
  };
};

export const isbnDeleteData = (id) => {
  return async (dispatch) => {
    const resp = await DataService.delete(API.isbn.isbnCreate + "/" + id);
    if (!resp.data.error) {
      return resp.data.data;
    } else {
      message.error(resp.data.message);
    }
  };
};
